import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { LocalTypeViewControllerDelegate, LocalTypeViewController } from "../../Screen/LocalType/LocalTypeController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { LocalTypeViewModel } from '../../Screen/LocalType/LocalTypeViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class LocalTypeCoordinator implements IndexCoordinatorDelegate, LocalTypeViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geptipolocal")
        return (<ProtectedRoute requiredPermissions={['dengue.tipo_local.*']} path="/:base/dengue/tipo-local" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.tipo_local.adicionar',
                    edit: 'dengue.tipo_local.editar',
                    delete: 'dengue.tipo_local.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Tipo de Local"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new LocalTypeViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.tipo_local.adicionar', 'dengue.tipo_local.editar']} path="/:base/dengue/tipo-local/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<LocalTypeViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipolocal") {
            navigation.history.push(`tipo-local/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipolocal") {
            navigation.history.push(`tipo-local/cad/${idSelection}`);
            return;
        }
    }

}